import { useState } from "react";
import { useHistory } from "react-router-dom";

import Form from "../../layout/Form";
import FormFieldText from "../../input/FormFieldText";

import useTriggeredAPICall from "../../../hooks/fetch-hooks/useTriggeredAPICall";
import { isValidEmail } from "../../../util/stringUtils";
import { errorToast, successfulToast } from "../../../util/toastNotifications";

import { Link } from "react-router-dom";
import Logo from "../../../assets/images/twlogo.svg";
import SubtlePrism from "../../../assets/images/subtle-prism.svg";

const ForgotPassword = () => {
  const [formErrors, setFormErrors] = useState({});
  const [email, setEmail] = useState("");

  const history = useHistory();
  const { fetchData } = useTriggeredAPICall();

  const inputErrors = () => {
    const errors = {};

    if (!isValidEmail(email)) {
      errors["email"] = "Invalid Email";
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleFieldUpdate = (e) => {
    const { name, value } = e.target;

    setEmail(value);

    if (inputErrors[name]) {
      setFormErrors((previous) => ({
        ...previous,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validateErrors = inputErrors();

    if (validateErrors) {
      setFormErrors(validateErrors);
    } else {
      fetchData("/auth/forgot-password", "POST", { email }, null, false)
        .then(() => {
          successfulToast("Password reset link sent. Check your email.");
          setEmail("");
          history.push("/login/email-verification");
        })
        .catch(() => {
          errorToast("Failed to send reset link. Please try again.");
        });
    }
  };

  return (
    <div
      className="width-full height-full flex-columns flex-align-center"
      style={{ backgroundImage: `url(${SubtlePrism})` }}
    >
      <Link to="/login">
        <img className="mt-32 mb-16 height-20" src={Logo} alt="Logo" />
      </Link>
      <div className="width-500px height-600px py-8 px-16 card center">
        <h2>Reset Your Password</h2>
        <p>Don't worry, it happens to the best of us.</p>
        <p>
          Just enter your email address below and we will send you a password
          reset link.
        </p>

        <Form className="" handleSubmit={handleSubmit}>
          <FormFieldText
            name="email"
            label="Email"
            placeholder="Enter your email..."
            type="email"
            value={email}
            onChange={handleFieldUpdate}
            errorMessage={formErrors?.email}
          ></FormFieldText>
          <button
            className="create-btn"
            type="submit"
            disabled={formErrors?.email || !email}
          >
            Send me a recovery link
          </button>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
